import { Component, HostBinding, Inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FeatureFlagService } from 'src/app/core/feature-flags/feature-flag.service';
import { AppWindow } from '../../AppWindow';
import { EnterpriseConfigurationDataAccessService } from '../../shared/modules/enterprise-configuration/enterprise-configuration-data-access.service';
import { AbstractHeader } from '../abstract-header';

@Component({
  selector: 'app-unauthenticated-header',
  templateUrl: './unauthenticated-header.component.html',
  styleUrls: ['./unauthenticated-header.component.scss'],
})
export class UnauthenticatedHeaderComponent extends AbstractHeader {
  @HostBinding('class.site-header')
  private _siteHeader: boolean = true;

  constructor(
    _enterpriseConfigurationService: EnterpriseConfigurationDataAccessService,
    _featureService: FeatureFlagService,
    _sanitizer: DomSanitizer,
    @Inject('window') private _window: AppWindow,
  ) {
    super(_enterpriseConfigurationService, _sanitizer);
  }

  navigateToSignUp() {
    if (this._window.portalConfig && typeof this._window.portalConfig.signUpUrl === 'string') {
      this._window.location.href = this._window.portalConfig.signUpUrl;
    }
  }
  public onClick(){
    window.open("https://digital-trial-dev.onboarding.cloud.precisely.services/signup?moduleName=enrich", '_blank');
  }
}
